import { isEmpty, isNull } from "lodash";
import {
  renderNull,
  renderRiskClassName,
  getDataSourceIcon,
  createRenderHeader,
} from "../Dashboard/ContentPages/SysGuardColumnConfig";
import { useSelector } from "react-redux";
import { maskUsername, userTimeZone } from "../SysGuardCommonComp";
import moment from "moment";
import { Chip } from "@material-ui/core";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import Tooltip from "@material-ui/core/Tooltip";

export const attemptStatusIcons = {
  LOGIN_SUCCESS: <CheckCircleIcon style={{ color: "green" }} />,
  LOGIN_FAILURE: <CancelIcon style={{ color: "red" }} />,
};

const renderLocationWithRisk = (params) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    return (
      <div className={renderRiskClassName(params.row.countryRisk)}>
        {params.value}
      </div>
    );
  }
};

export const createPopupRenderHeader =
  (
    headerName,
    field,
    activeFilterField,
    handleFilterIconClick,
    showFilter = true,
  ) =>
  () => {
    const isActive = activeFilterField === field;

    return (
      <div
        className={`tableHeaderCell popup-header ${
          showFilter ? "filter-enabled" : "filter-disabled"
        }`}
      >
        <span className="headerText">{headerName}</span>

        {showFilter && (
          <span
            className="tableFilterIcon"
            onClick={(e) => {
              e.stopPropagation();
              handleFilterIconClick(e, field);
            }}
          >
            <img
              src={
                isActive
                  ? "/sysGuardIcons/filter_list.svg"
                  : "/sysGuardIcons/filter_list_notSelected.svg"
              }
              alt="filter-icon"
            />
          </span>
        )}
      </div>
    );
  };

const RenderUserName = (params) => {
  const isIncognito = useSelector((state) => state.SysGuardReducer.incognito);
  if (isNull(params.value) || isEmpty(params.value)) {
    return <div className="sys-guard-status">Unknown</div>;
  } else if (isIncognito) {
    return <div className="sys-guard-status">{maskUsername(params.value)}</div>;
  } else {
    return (
      <div className="sys-guard-status" title={params.value}>
        {params.value}
      </div>
    );
  }
};

const RenderDataSourceChip = (params) => {
  const sysGuardDataSource = useSelector(
    (state) => state.SysGuardReducer.sysGuardDataSource,
  );
  const datasourceId = params.row?.dataSourceId;

  if (!datasourceId) {
    return renderNull();
  }

  const ds = sysGuardDataSource?.[datasourceId];

  if (!ds) {
    return renderNull();
  }

  return (
    <Chip
      title={ds?.domainName}
      icon={
        <img
          src={getDataSourceIcon(ds?.typeCode)}
          alt={ds?.typeName}
          className="data-source-chip-icon"
        />
      }
      label={ds?.domainName}
      className="data-source-chip"
      size="small"
    />
  );
};

const renderClientIp = (params) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    return (
      <div className="sys-guard-client-ip" title={params.value}>
        {params.value}
      </div>
    );
  }
};

const renderName = (params) => {
  if (isNull(params.value) || isEmpty(params.value)) {
    return <div>Unknown</div>;
  } else {
    return (
      <div className="sys-guard-status" title={params.value}>
        {params.value}
      </div>
    );
  }
};

const renderStatusHeader = () => {
  return (
    <div className="sys-guard-attempt-status-header" title="Attempted Status">
      Attempted Status
    </div>
  );
};

const renderDateWitTimeZone = (title) => {
  return (
    <div
      className="sys-guard-date-status-header"
      title={`${title} (${userTimeZone})`}
    >
      <span>{title}</span>
      <span className="timeZone">({userTimeZone})</span>
    </div>
  );
};

const renderStatus = (params, loc) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    const row = params?.row;

    return (
      <Tooltip
        title={
          <div className="custom-tooltip-content">
            {loc !== "failure" ? (
              <>
                <div>
                  <strong>Device:</strong>{" "}
                  <span>{row?.deviceOs || "Unknown"}</span>
                </div>
                <div>
                  <strong>Browser:</strong>{" "}
                  <span>{row?.browser || "Unknown"}</span>
                </div>
              </>
            ) : null}
            {row?.actionPerformed === "LOGIN_SUCCESS" ? (
              <div>
                <strong>Login:</strong> <span>success</span>
              </div>
            ) : (
              <div>
                <strong>Error:</strong>{" "}
                <span>{row?.failureReason || "Unknown reason"}</span>
              </div>
            )}
          </div>
        }
        placement="top"
        arrow
        classes={{
          tooltip: "custom-tooltip-popup",
          arrow: "custom-arrow-popup",
        }}
      >
        <div className="sys-guard-status">
          {attemptStatusIcons[params.value]}
        </div>
      </Tooltip>
    );
  }
};

export const userLocationColumns = (
  handleFilterIconClick,
  activeFilterField,
  IsIncognito,
) => {
  return [
    {
      field: "date",
      flex: 1.5,
      align: "center",
      headerAlign: "center",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("DD-MM-YYYY"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "time",
      headerName: "Time",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderHeader: () => renderDateWitTimeZone(`Time`),
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("HH:mm"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "location",
      headerName: "City",
      flex: 3.5,
      align: "center",
      headerAlign: "center",
      renderHeader: createPopupRenderHeader(
        "City",
        "location",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => renderLocationWithRisk(params),
    },
    {
      field: "clientIp",
      headerName: "IP Address",
      flex: 2.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "IP Address",
        "clientIp",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => renderClientIp(params),
    },
    {
      field: "actionPerformed",
      headerName: "Attempted Status",
      flex: 1.3,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => renderStatus(params),
      renderHeader: () => renderStatusHeader(),
    },
  ];
}; 

export const userDeviceColumns = (
  handleFilterIconClick,
  activeFilterField,
  IsIncognito,
) => {
  return [
    {
      field: "date",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("DD-MM-YYYY"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "time",
      renderHeader: () => renderDateWitTimeZone(`Time`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("HH:mm"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "deviceName",
      headerName: "Device",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Device",
        "deviceName",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => renderName(params),
    },
    {
      field: "deviceOs",
      headerName: "Device OS",
      flex: 1,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Device OS",
        "deviceOs",
        activeFilterField,
        handleFilterIconClick,
      ),
    },
    {
      field: "actionPerformed",
      headerName: "Attempted Status",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => renderStatus(params),
      renderHeader: () => renderStatusHeader(),
    },
  ];
};

export const userAnomaliesColumn = (
  handleFilterIconClick,
  activeFilterField,
  IsIncognito,
) => {
  return [
    {
      field: "date",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("DD-MM-YYYY"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "time",
      renderHeader: () => renderDateWitTimeZone(`Time`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("HH:mm"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "policyName",
      headerName: "Policy",
      flex: 4,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Policy",
        "policyName",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => renderName(params),
    },
  ];
}; 

export const userApplicationsColumn = (
  handleFilterIconClick,
  activeFilterField,
  IsIncognito
) => {
  return [
    {
      field: "date",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      flex: 1.2,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("DD-MM-YYYY"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "time",
      renderHeader: () => renderDateWitTimeZone(`Time`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("HH:mm"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "appName",
      headerName: "Application",
      flex: 2.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Application",
        "appName",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => renderName(params),
    },
    {
      field: "deviceName",
      headerName: "Device",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Device",
        "deviceName",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => renderName(params),
    },
    {
      field: "actionPerformed",
      headerName: "Attempted Status",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => renderStatus(params),
      renderHeader: () => renderStatusHeader(),
    },
  ];
};

export const locationBasedUsersColumn = (
  handleFilterIconClick,
  activeFilterField,
  IsIncognito
) => {
  return [
    {
      field: "date",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("DD-MM-YYYY"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "time",
      renderHeader: () => renderDateWitTimeZone(`Time`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("HH:mm"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "userName",
      headerName: "User Name",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "User Name",
        "userName",
        activeFilterField,
        handleFilterIconClick,
        !IsIncognito,
      ),
      renderCell: (params) => RenderUserName(params),
    },
    {
      field: "dataSource",
      headerName: "Domain",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Domain",
        "dataSource",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => RenderDataSourceChip(params),
    },
    {
      field: "clientIp",
      headerName: "IP Address",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "IP Address",
        "clientIp",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => renderClientIp(params),
    },
    {
      field: "actionPerformed",
      headerName: "Attempted Status",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => renderStatus(params),
      renderHeader: () => renderStatusHeader(),
    },
  ];
}; 

export const locationBasedAnomaliesColumn = (
  handleFilterIconClick,
  activeFilterField,
  IsIncognito,
) => {
  return [
    {
      field: "date",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("DD-MM-YYYY"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "time",
      renderHeader: () => renderDateWitTimeZone(`Time`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("HH:mm"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "userName",
      headerName: "User Name",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "User Name",
        "userName",
        activeFilterField,
        handleFilterIconClick,
        !IsIncognito,
      ),
      renderCell: (params) => RenderUserName(params),
    },
    {
      field: "dataSource",
      headerName: "Domain",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Domain",
        "dataSource",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => RenderDataSourceChip(params),
    },
    {
      field: "clientIp",
      headerName: "IP Address",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "IP Address",
        "clientIp",
        activeFilterField,
        handleFilterIconClick,
      ),
    },
  ];
}; 

export const userBasedFailurePercentageColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1.6,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "location",
    headerName: "location",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "deviceOs",
    headerName: "Device",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "browser",
    headerName: "Browser",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params, "failure"),
    renderHeader: () => renderStatusHeader(),
  },
];

export const applicationBasedFailurePercentageColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1.6,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "city",
    headerName: "City",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.2,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "deviceOs",
    headerName: "Device",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params, "failure"),
    renderHeader: () => renderStatusHeader(),
  },
];

export const locationBasedFailurePercentageColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1.6,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "city",
    headerName: "City",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.2,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "deviceOs",
    headerName: "Device",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
 {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params, "failure"),
    renderHeader: () => renderStatusHeader(),
  },
];

export const cityBasedFailurePercentageColumn = [
  {
    field: "date",
    renderHeader: () => renderDateWitTimeZone(`Date`),
    flex: 1.6,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("DD-MM-YYYY"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "time",
    renderHeader: () => renderDateWitTimeZone(`Time`),
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (params) => params?.row?.timeStamp,
    valueFormatter: (params) =>
      moment.utc(params?.value).local().format("HH:mm"),
    sortComparator: (v1, v2) => v1 - v2,
  },
  {
    field: "userName",
    headerName: "User Name",
    flex: 1.2,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
  {
    field: "dataSource",
    headerName: "Domain",
    flex: 1.5,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => RenderDataSourceChip(params),
  },
  {
    field: "deviceOs",
    headerName: "Device",
    flex: 1.1,
    align: "left",
    headerAlign: "left",
    renderCell: (params) => renderName(params),
  },
 {
    field: "actionPerformed",
    headerName: "Attempted Status",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => renderStatus(params, "failure"),
    renderHeader: () => renderStatusHeader(),
  },
];

export const locationBasedApplicationColumn = (
  handleFilterIconClick,
  activeFilterField,
  IsIncognito
) => {
  return [
    {
      field: "date",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("DD-MM-YYYY"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "time",
      renderHeader: () => renderDateWitTimeZone(`Time`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("HH:mm"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "appName",
      headerName: "Application",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Application",
        "appName",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => renderName(params),
    },
    {
      field: "userName",
      headerName: "User Name",
      flex: 1.7,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "User Name",
        "userName",
        activeFilterField,
        handleFilterIconClick,
        !IsIncognito,
      ),
      renderCell: (params) => RenderUserName(params),
    },
    {
      field: "dataSource",
      headerName: "Domain",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Domain",
        "dataSource",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => RenderDataSourceChip(params),
    },
    {
      field: "actionPerformed",
      headerName: "Attempted Status",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => renderStatus(params),
      renderHeader: () => renderStatusHeader(),
    },
  ];
};

export const applicationBasedUsersColumn = (
  handleFilterIconClick,
  activeFilterField,
  IsIncognito
) => {
  return [
    {
      field: "date",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("DD-MM-YYYY"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "time",
      renderHeader: () => renderDateWitTimeZone(`Time`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("HH:mm"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "userName",
      headerName: "User Name",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "User Name",
        "userName",
        activeFilterField,
        handleFilterIconClick,
        !IsIncognito
      ),
      renderCell: (params) => RenderUserName(params),
    },
    {
      field: "dataSource",
      headerName: "Domain",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Domain",
        "dataSource",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => RenderDataSourceChip(params),
    },
    {
      field: "deviceName",
      headerName: "Device",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Device",
        "deviceName",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => renderName(params),
    },
    {
      field: "actionPerformed",
      headerName: "Attempted Status",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => renderStatus(params),
      renderHeader: () => renderStatusHeader(),
    },
  ];
}; 

export const applicationBasedAnomaliesColumn = (handleFilterIconClick, activeFilterField, isIncognito) => {
  return [
    {
      field: "date",
      renderHeader: () => renderDateWitTimeZone(`Date`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("DD-MM-YYYY"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "time",
      renderHeader: () => renderDateWitTimeZone(`Time`),
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => params?.row?.timeStamp,
      valueFormatter: (params) =>
        moment.utc(params?.value).local().format("HH:mm"),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "userName",
      headerName: "User Name",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "User Name",
        "userName",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => RenderUserName(params),
    },
    {
      field: "dataSource",
      headerName: `Domain`,
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderHeader: createPopupRenderHeader(
        "Domain",
        "dataSource",
        activeFilterField,
        handleFilterIconClick,
      ),
      renderCell: (params) => RenderDataSourceChip(params),
    },
  ];
}; 
